/**
 * §P.2 · El marco de «Calendario».
 *
 * Dos pantallas y no una porque son las dos caras de la misma semana: **qué clases
 * hay** y **quién ha dicho que no viene**. Antes solo estaba la primera, y las
 * justificaciones vivían dentro del `roster` de cada sesión: para saber quién avisó
 * había que abrir clase por clase.
 *
 * Sin guardián de rol: las dos rutas de debajo son `own`, `adm` y `coa`, y quien da
 * la clase es justamente quien más necesita saber quién no va a venir.
 */
import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { VISTAS_DEL_CALENDARIO } from '@/club/secciones';

export function MarcoDelCalendario() {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas del calendario">
        {VISTAS_DEL_CALENDARIO.map((v) => {
          const destino = `/calendario/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
